import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useProductCategories, useProductOrigins } from '@/hooks/warehouse';
import BaseFilters from '@/components/v2/molecules/admin/shared/BaseFilters';

interface ProductFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  selectedCategory: string;
  setSelectedCategory: (value: string) => void;
  selectedOrigin: string;
  setSelectedOrigin: (value: string) => void;
  hasActiveFilters: boolean;
  clearFilters: () => void;
}

const ProductFilters = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  selectedOrigin,
  setSelectedOrigin,
  hasActiveFilters,
  clearFilters,
}: ProductFiltersProps) => {
  const { categories } = useProductCategories();
  const { origins } = useProductOrigins();

  return (
    <BaseFilters
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      searchPlaceholder="Buscar por nombre o descripción..."
      searchWidth="w-[200px]"
      hasActiveFilters={hasActiveFilters}
      onClearFilters={clearFilters}
      hideDatePicker
    >
      {/* Category Selector */}
      <Select value={selectedCategory} onValueChange={setSelectedCategory}>
        <SelectTrigger className="w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0">
          <SelectValue placeholder="Todas las categorías" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas las categorías</SelectItem>
          {categories.map((cat) => (
            <SelectItem key={cat.id} value={cat.id}>
              {cat.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Origin Selector */}
      <Select value={selectedOrigin} onValueChange={setSelectedOrigin}>
        <SelectTrigger className="w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0">
          <SelectValue placeholder="Todos los orígenes" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los orígenes</SelectItem>
          {origins.map((origin) => (
            <SelectItem key={origin.id} value={origin.id}>
              {origin.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </BaseFilters>
  );
};

export default ProductFilters;
